/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TagsPicker/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import Tags from './Tags/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TagsPicker({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Tags/TagsPicker",
  setOuterRef,
  disabled,
  left,
  top,
  setInnerRef
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let taskTaskTagsValueData = fromData.useDataFormat({ viewPath,
context: 'task',
path: 'task_tags',
format: fromHelpers.getLabel,
})
let dtFontsizesMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'fontSizes.mm'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<div
  data-testid="TagsPicker.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-2hY6mc': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TagsPicker.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
 cursor="pointer"
 paddingLeft={0}
 paddingRight={0}
 innerRef={setOuterRef}
 onClick={flow.has(fromFlow.normalizePath(viewPath, 'Content')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, 'No')) : () => setFlowTo(fromFlow.normalizePath(viewPath, 'Content'))}
>
{childProps => (
<React.Fragment>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="task.task_tags"
 format="./helpers.js getLabel"
 text={taskTaskTagsValueData}
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 fontSize={dtFontsizesMm}
 marginLeft={0}
 marginRight={dtSpaceXxs}
 color={dtColorsNeutral900}
/>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconArrowDown
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 width={14}
 height={14}
 fill2={disabled ? dtColorsNeutral300 : dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
</React.Fragment>
)}
</TysiaButton>
</div>
<Tags
  viewPath={`${viewPath}/Tags`}
/>
</div>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 left={left}
 top={top}
 innerRef={setInnerRef}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}